import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SecuredHomeComponent } from './secured-home/secured-home.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { RouterModule } from '@angular/router';
import { CanActivateViaAuthGuard } from '../shared/guards/can-activate-via-auth-guard';
import { SharedModule } from '../shared/shared.module';
import { CanActivateViaGuestGuard } from '../shared/guards/can-activate-via-guest-guard';
import { PermissionGuard } from '../shared/guards/permission-guard';
import { routes } from './auth.routes';
import { ExternalLoginExpiredComponent } from './external-login-expired/external-login-expired.component';
import { PermissionModule } from '../permission/permission.module';
import { AuthenticationStore } from '../permission/services/authentication.store';
import { AuthenticationHttpService } from '../permission/services/authentication.http.service';
import { FinalPaymentAuthorizedGuard } from '../shared/guards/final-payment-authorized.guard';
import { AllowApiDocsGuard } from '../shared/guards/allow-api-docs.guard';
import { DashboardRedirectGuard } from '../shared/guards/dashboard-redirect-guard';
import { OverviewRedirectGuard } from '../shared/guards/overview-redirect-guard';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    PermissionModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    LoginComponent,
    LogoutComponent,
    SecuredHomeComponent,
    ExternalLoginExpiredComponent
  ],
  providers: [
    CanActivateViaAuthGuard,
    CanActivateViaGuestGuard,
    PermissionGuard,
    FinalPaymentAuthorizedGuard,
    AuthenticationStore,
    AuthenticationHttpService,
    AllowApiDocsGuard,
    DashboardRedirectGuard,
    OverviewRedirectGuard
  ],
  exports: []
})
export class AuthModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/auth.module.ts